var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar (12) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.93351 30.501C4.78654 30.501 2 27.7145 2 23.5675V10.4345C2 6.28752 4.78648 3.50098 8.93351 3.50098H23.0665C27.2135 3.50098 30 6.28746 30 10.4345V23.5675C30 27.7144 27.2135 30.501 23.0665 30.501H8.93351Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.93351 30C4.78654 30 2 27.2135 2 23.0665V9.93351C2 5.78654 4.78648 3 8.93351 3H23.0665C27.2135 3 30 5.78648 30 9.93351V23.0665C30 27.2135 27.2135 30 23.0665 30H8.93351Z",
    fill: "url(#paint0_linear_6064_13281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2 10V9.93351C2 5.78654 4.78648 3 8.93351 3H23.0665C27.2135 3 30 5.78648 30 9.93351V10H2Z",
    fill: "#F4413D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.0665 3H8.93351C4.78654 3 2 5.78648 2 9.93351V23.0665C2 27.2135 4.78648 30 8.93351 30H23.0665C27.2135 30 30 27.2135 30 23.0665V9.93351C30 5.78648 27.2135 3 23.0665 3ZM29 23.0665C29 26.671 26.671 29 23.0665 29H8.93351C5.32899 29 3 26.671 3 23.0665V9.93351C3 6.32899 5.32899 4 8.93351 4H23.0665C26.671 4 29 6.32899 29 9.93351V23.0665Z",
    fill: "url(#paint1_linear_6064_13281)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.788 18.4427H12.9366C14.2286 18.4427 15.117 17.6497 15.117 16.5491C15.117 15.4826 14.3105 14.7306 12.9775 14.7306C11.754 14.7306 10.8855 15.4691 10.783 16.5627H9.88055C9.99655 14.9767 11.241 13.9102 13.018 13.9102C14.7545 13.9102 16.06 14.9697 16.06 16.4326C16.06 17.6701 15.26 18.5586 14.0025 18.7841V18.8116C15.513 18.9006 16.484 19.8371 16.484 21.2316C16.484 22.8996 14.994 24.0891 13.073 24.0891C11.0836 24.0891 9.73705 22.9541 9.67554 21.3751H10.578C10.653 22.4756 11.6445 23.2686 13.0665 23.2686C14.495 23.2686 15.5345 22.4276 15.5345 21.2586C15.5345 20.0006 14.564 19.2351 12.978 19.2351H11.7885C11.788 19.2356 11.788 18.4427 11.788 18.4427Z",
    fill: "#413D3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.4221 15.0592H20.3946C20.2377 15.1547 18.5287 16.3922 17.7491 16.8777V15.8797C18.0432 15.6952 20.1346 14.2187 20.4082 14.0547H21.3242V23.9327H20.4217L20.4221 15.0592Z",
    fill: "#413D3D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.24,
    d: "M8.50022 7.99996C9.32864 7.99996 10.0002 7.32839 10.0002 6.49998C10.0002 5.67156 9.32864 5 8.50022 5C7.67181 5 7.00024 5.67156 7.00024 6.49998C7.00024 7.32839 7.67181 7.99996 8.50022 7.99996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.24,
    d: "M23.5007 7.99996C24.3291 7.99996 25.0007 7.32839 25.0007 6.49998C25.0007 5.67156 24.3291 5 23.5007 5C22.6723 5 22.0007 5.67156 22.0007 6.49998C22.0007 7.32839 22.6723 7.99996 23.5007 7.99996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.0665 3H8.93351C4.78654 3 2 5.78648 2 9.93351V23.0665C2 27.2135 4.78648 30 8.93351 30H23.0665C27.2135 30 30 27.2135 30 23.0665V9.93351C30 5.78648 27.2135 3 23.0665 3ZM29.5 23.0665C29.5 26.9145 26.9145 29.5 23.0665 29.5H8.93351C5.08551 29.5 2.50003 26.9145 2.50003 23.0665V9.93351C2.50003 6.08551 5.08551 3.50003 8.93351 3.50003H23.0665C26.9145 3.50003 29.5 6.08551 29.5 9.93351V23.0665Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.50083 7.00002C8.22485 7.00002 8.00085 6.77603 8.00085 6.50005V2.49997C8.00085 2.22399 8.22485 2 8.50083 2C8.77681 2 9.0008 2.22399 9.0008 2.49997V6.49999C9.00086 6.77597 8.77681 7.00002 8.50083 7.00002Z",
    fill: "url(#paint2_linear_6064_13281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.5006 7.00002C23.2246 7.00002 23.0006 6.77603 23.0006 6.50005V2.49997C23.0006 2.22399 23.2246 2 23.5006 2C23.7766 2 24.0006 2.22399 24.0006 2.49997V6.49999C24.0006 6.77597 23.7766 7.00002 23.5006 7.00002Z",
    fill: "url(#paint3_linear_6064_13281)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6064_13281",
    x1: 16,
    y1: 29.9985,
    x2: 16,
    y2: 2.99844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6064_13281",
    x1: 16,
    y1: 29.9985,
    x2: 16,
    y2: 2.99844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6064_13281",
    x1: 8.50078,
    y1: 6.99846,
    x2: 8.50078,
    y2: 1.99844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6064_13281",
    x1: 23.5006,
    y1: 6.99846,
    x2: 23.5006,
    y2: 1.99844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCalendar);
export default __webpack_public_path__ + "static/media/appleCalendar.89342e02f6031def15bfa2bcaf3ba7db.svg";
export { ForwardRef as ReactComponent };